'use es6';

import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import UIMain from '../layout/UIMain';
import * as CustomRenderer from '../utils/propTypes/customRenderer';
import { GRID_BREAKPOINT_SMALL, NAV_ITEM_PADDING_LEFT } from 'HubStyleTokens/sizes';
var Outer = styled.div.withConfig({
  displayName: "UIAbstractPageGridContent__Outer",
  componentId: "qbkf6m-0"
})(["display:flex;flex-wrap:nowrap;margin-left:-16px;margin-right:-16px;@media only screen and (max-width:", "){flex-wrap:wrap;}"], GRID_BREAKPOINT_SMALL);
var Sidebar = styled.div.withConfig({
  displayName: "UIAbstractPageGridContent__Sidebar",
  componentId: "qbkf6m-1"
})(["flex:0 0 33%;max-width:224px;padding-left:16px;padding-right:16px;position:relative;@media only screen and (max-width:", "){flex-basis:100%;max-width:none;}"], GRID_BREAKPOINT_SMALL);
var MainContainer = styled.div.withConfig({
  displayName: "UIAbstractPageGridContent__MainContainer",
  componentId: "qbkf6m-2"
})(["flex:1 0 0%;max-width:", ";padding-left:16px;padding-right:16px;position:relative;@media only screen and (max-width:679px){max-width:", ";}@media only screen and (max-width:", "){flex-basis:100%;max-width:100%;}"], function (_ref) {
  var hasSidebar = _ref.hasSidebar;
  return hasSidebar ? 'calc(100% - 224px)' : '100%';
}, function (_ref2) {
  var hasSidebar = _ref2.hasSidebar;
  return hasSidebar && '67%';
}, GRID_BREAKPOINT_SMALL);
var STICKY_STYLES = css(["height:100vh;margin-left:-", ";overflow-y:auto;padding-left:", ";position:sticky;top:0;@media only screen and (max-width:", "){height:auto;}"], NAV_ITEM_PADDING_LEFT, NAV_ITEM_PADDING_LEFT, GRID_BREAKPOINT_SMALL);
var SidebarContainer = styled.div.withConfig({
  displayName: "UIAbstractPageGridContent__SidebarContainer",
  componentId: "qbkf6m-3"
})(["", ";"], function (props) {
  return props.stickySidebar && STICKY_STYLES;
});
export default function UIAbstractPageGridContent(props) {
  var children = props.children,
      sidebarComponent = props.sidebarComponent,
      stickySidebar = props.stickySidebar;
  return React.createElement(Outer, null, sidebarComponent && React.createElement(Sidebar, null, React.createElement(SidebarContainer, {
    stickySidebar: stickySidebar
  }, CustomRenderer.render(sidebarComponent))), React.createElement(MainContainer, {
    hasSidebar: !!sidebarComponent
  }, React.createElement(UIMain, {
    flush: true
  }, children)));
}
UIAbstractPageGridContent.propTypes = {
  children: PropTypes.node,
  sidebarComponent: CustomRenderer.propType,
  stickySidebar: PropTypes.bool
};
UIAbstractPageGridContent.defaultProps = {
  stickySidebar: false
};
UIAbstractPageGridContent.displayName = 'UIAbstractPageGridContent';